import React from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material'
import BarChartIcon from '@mui/icons-material/BarChart'
import PersonIcon from '@mui/icons-material/Person'
import CalculateIcon from '@mui/icons-material/Calculate'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import InsightsIcon from '@mui/icons-material/Insights'
import PublicIcon from '@mui/icons-material/Public'
import { useAuth } from '../../hooks/useAuth'

const tabs = [
  { label: 'Statistik', path: '/performance/stats', icon: <InsightsIcon /> },
  { label: 'Hele sitet', path: '/performance/site', icon: <PublicIcon />, adminOnly: true },
  { label: 'Profil', path: '/performance/profile', icon: <PersonIcon /> },
  { label: 'Prisberegner', path: '/performance/prisberegner', icon: <CalculateIcon /> },
  { label: 'Oversigt', path: '/performance/overview', icon: <AdminPanelSettingsIcon />, adminOnly: true },
]

export default function PerformancePage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { isAdmin } = useAuth()

  const visibleTabs = tabs.filter((tab) => !tab.adminOnly || isAdmin)
  const currentTab = visibleTabs.findIndex((tab) => location.pathname.startsWith(tab.path))

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    navigate(visibleTabs[newValue].path)
  }

  return (
    <Box>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
          <BarChartIcon sx={{ color: 'primary.main', fontSize: 28 }} />
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              background: 'linear-gradient(135deg, #5c4b99 0%, #7c6baf 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Performance
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary">
          Se statistik og analyser for dine profiler og Prisberegner-visninger
        </Typography>
      </Box>

      {/* Tabs */}
      <Paper
        elevation={0}
        sx={{
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Tabs
          value={currentTab >= 0 ? currentTab : 0}
          onChange={handleTabChange}
          sx={{
            px: 2,
            '& .MuiTab-root': {
              minHeight: 56,
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.9rem',
              gap: 1,
            },
            '& .Mui-selected': {
              color: 'primary.main',
            },
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: '3px 3px 0 0',
            },
          }}
        >
          {visibleTabs.map((tab) => (
            <Tab
              key={tab.path}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
            />
          ))}
        </Tabs>
      </Paper>

      {/* Content */}
      <Outlet />
    </Box>
  )
}
